import React from 'react';

const TranslatableOption = ({ text, value }) => (
  <option value={value}>
    {text}
  </option>
);

export default TranslatableOption;
